import { Unit } from '@rematter/frontend-lib-api-client';

import { TierInput } from '../types/pricing';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const defaultPriceListAddItemPricingAtom = createMutationAtomFactory(
  'brokerage.defaultPriceListAddItemPricing',
  (params: {
    priceListId: string;
    itemId: string;
    pricingUnit: Unit;
    position: number;
    tiers: TierInput[];
  }) => ({
    pricingDefaultPriceListAddItemPricing: {
      __args: {
        priceListId: params.priceListId,
        input: {
          itemId: params.itemId,
          pricingUnit: params.pricingUnit,
          position: params.position,
          tiers: params.tiers,
        },
      },
      id: true,
      item: {
        id: true,
        name: true,
      },
      pricingUnit: true,
      position: true,
    },
  }),
);

export const defaultPriceListUpdateItemPricingAtom = createMutationAtomFactory(
  'brokerage.defaultPriceListUpdateItemPricing',
  (params: {
    itemPricingId: string;
    pricingUnit?: Unit;
    position?: number;
    tiers?: TierInput[];
  }) => ({
    pricingDefaultPriceListUpdateItemPricing: {
      __args: {
        itemPricingId: params.itemPricingId,
        input: {
          pricingUnit: params.pricingUnit,
          position: params.position,
          tiers: params.tiers,
        },
      },
      id: true,
      pricingUnit: true,
      position: true,
    },
  }),
);

export const defaultPriceListDeleteItemPricingAtom = createMutationAtomFactory(
  'brokerage.defaultPriceListDeleteItemPricing',
  (params: { itemPricingId: string }) => ({
    pricingDefaultPriceListDeleteItemPricing: {
      __args: {
        itemPricingId: params.itemPricingId,
      },
    },
  }),
);

export const defaultPriceListReorderItemPricingsAtom =
  createMutationAtomFactory(
    'brokerage.defaultPriceListReorderItemPricings',
    (params: { priceListId: string; itemPricingIds: string[] }) => ({
      pricingDefaultPriceListReorderItemPricings: {
        __args: {
          priceListId: params.priceListId,
          itemPricingIds: params.itemPricingIds,
        },
      },
    }),
  );

export const defaultPriceListBatchUpdateItemPricingsAtom =
  createMutationAtomFactory(
    'brokerage.defaultPriceListBatchUpdateItemPricings',
    (params: {
      priceListId: string;
      items: {
        itemPricingId: string;
        input: Record<string, unknown>;
        tiers?: TierInput[];
      }[];
    }) => ({
      pricingDefaultPriceListBatchUpdateItemPricings: {
        __args: {
          priceListId: params.priceListId,
          items: params.items,
        },
        id: true,
        pricingUnit: true,
        position: true,
        tiersEffectiveAt: true,
      },
    }),
  );

export const defaultPriceListUpdateNotesAtom = createMutationAtomFactory(
  'brokerage.defaultPriceListUpdateNotes',
  (params: { priceListId: string; notes: string | null }) => ({
    pricingDefaultPriceListUpdateNotes: {
      __args: {
        priceListId: params.priceListId,
        notes: params.notes,
      },
      id: true,
      notes: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);

export const defaultPriceListCopyFromAtom = createMutationAtomFactory(
  'brokerage.defaultPriceListCopyFrom',
  (params: {
    targetDefaultPriceListId: string;
    sourceCustomPriceListId?: string;
    sourceDefaultPriceListId?: string;
  }) => ({
    pricingDefaultPriceListCopyFrom: {
      __args: {
        targetDefaultPriceListId: params.targetDefaultPriceListId,
        sourceCustomPriceListId: params.sourceCustomPriceListId,
        sourceDefaultPriceListId: params.sourceDefaultPriceListId,
      },
      id: true,
      item: {
        id: true,
        name: true,
      },
      pricingUnit: true,
      position: true,
    },
  }),
);

export const defaultPriceListImportFromAtom = createMutationAtomFactory(
  'brokerage.defaultPriceListImportFrom',
  (params: { targetDefaultPriceListId: string; itemPricingIds: string[] }) => ({
    pricingDefaultPriceListImportFrom: {
      __args: {
        targetDefaultPriceListId: params.targetDefaultPriceListId,
        itemPricingIds: params.itemPricingIds,
      },
      id: true,
      item: {
        id: true,
        name: true,
      },
      pricingUnit: true,
      position: true,
    },
  }),
);

export const defaultPriceListAddProductPricingAtom =
  defaultPriceListAddItemPricingAtom;
export const defaultPriceListUpdateProductPricingAtom =
  defaultPriceListUpdateItemPricingAtom;
export const defaultPriceListDeleteProductPricingAtom =
  defaultPriceListDeleteItemPricingAtom;
export const defaultPriceListReorderProductPricingsAtom =
  defaultPriceListReorderItemPricingsAtom;
export const defaultPriceListBatchUpdateProductPricingsAtom =
  defaultPriceListBatchUpdateItemPricingsAtom;
